import { Link } from 'react-router-dom';
import { useState } from 'react';
import { postNewsletter } from '@/lib/api';
import BrandMark from '@/components/BrandMark';

export default function Footer() {
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setBusy(true);
        try {
            const res = await postNewsletter(email);
            setMsg(res.message || "You're on the list.");
            setEmail('');
            setSubscribed(true);
        } catch { setMsg('Something went wrong. Please try again.'); }
        finally { setBusy(false); }
    };

    return (
        <footer data-testid="site-footer" className="rule-top mt-24" style={{ background: 'var(--sand)' }}>
            <div className="container-page py-32 md:py-40 text-center">
                <span className="label">Join the circle</span>
                <h3 className="display-l mt-8 mx-auto" style={{ maxWidth: 780 }}>
                    Invitations to private viewings, openings, and the <span className="serif-italic">quiet release of new works.</span>
                </h3>
                <p className="literary mt-8 mx-auto measure-tight">
                    Two to four letters a year. Never a newsletter.
                </p>
                <div className="mt-12 max-w-md mx-auto min-h-[64px] flex items-center justify-center" aria-live="polite" data-testid="newsletter-region">
                    {!subscribed ? (
                        <form onSubmit={submit} className="w-full flex items-end gap-8" data-testid="newsletter-form">
                            <input data-testid="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="input-line flex-1 text-center" />
                            <button data-testid="newsletter-submit" type="submit" disabled={busy} className="btn-text whitespace-nowrap">{busy ? 'Sending' : 'Subscribe'}</button>
                        </form>
                    ) : (
                        <p
                            data-testid="newsletter-message"
                            role="status"
                            className="newsletter-success"
                            style={{
                                fontFamily: "'Cormorant Garamond', Georgia, serif",
                                fontStyle: 'italic',
                                fontWeight: 500,
                                fontSize: 21,
                                lineHeight: 1.4,
                                letterSpacing: '-0.005em',
                                color: 'var(--ink)',
                                margin: 0,
                            }}
                        >
                            {msg}
                        </p>
                    )}
                </div>
                {msg && !subscribed && (
                    <p
                        data-testid="newsletter-error"
                        className="newsletter-success"
                        style={{
                            marginTop: 20,
                            fontFamily: "'Cormorant Garamond', Georgia, serif",
                            fontStyle: 'italic',
                            fontSize: 16,
                            color: 'var(--clay-deep, #9C5A2E)',
                        }}
                    >
                        {msg}
                    </p>
                )}
            </div>

            <div className="rule-top">
                <div className="container-page py-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
                    <div>
                        <BrandMark
                            variant="dark"
                            size={44}
                            wordmarkSize={26}
                            showSubline={false}
                        />
                        <div className="wordmark-sub mt-2">Sydney · Est. 2026</div>
                    </div>
                    <div className="flex flex-col gap-2 caption" style={{ fontStyle: 'normal', color: 'var(--ink-2)' }}>
                        <span className="label label-quiet">Gallery</span>
                        <Link to="/artists" className="hover:text-[var(--ink)]">Artists</Link>
                        <Link to="/exhibitions" className="hover:text-[var(--ink)]">Exhibitions</Link>
                        <Link to="/artworks" className="hover:text-[var(--ink)]">Collections</Link>
                        <Link to="/private-viewing" className="hover:text-[var(--ink)]">Private Viewing</Link>
                        <Link to="/journal" className="hover:text-[var(--ink)]">Journal</Link>
                        <Link to="/about" className="hover:text-[var(--ink)]">About</Link>
                    </div>
                    <div className="flex flex-col gap-2 caption" style={{ fontStyle: 'normal', color: 'var(--ink-2)' }}>
                        <span className="label label-quiet">Contact</span>
                        <a href="mailto:art@maisontoure.com" className="hover:text-[var(--ink)]">art@maisontoure.com</a>
                        <a href="tel:+61480682055" className="hover:text-[var(--ink)]">+61 480 682 055</a>
                        <a href="https://www.instagram.com/maisontoure.art" target="_blank" rel="noreferrer" className="hover:text-[var(--ink)]">Instagram</a>
                    </div>
                </div>
                <div className="container-page rule-top py-6 flex flex-col md:flex-row justify-between gap-3 label label-quiet">
                    <span>© 2026 Maison Touré · All rights reserved</span>
                    <span className="serif-italic" style={{ textTransform: 'none', letterSpacing: 0, fontSize: 14, fontWeight: 400 }}>Founded by Fatym Touré · Sydney</span>
                </div>
            </div>
        </footer>
    );
}
